import axios from 'axios';
import { installOtpCapability } from '../lib/otpChannel';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'https://localhost:5001/api', withCredentials: true, headers: { 'ngrok-skip-browser-warning': 'true' } });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  const explicitAuthorization = typeof config.headers?.get === 'function'
    ? config.headers.get('Authorization')
    : (config.headers?.Authorization || config.headers?.authorization);
  // Ein eng begrenzter MFA-Setup-Bearer wird absichtlich pro Anfrage gesetzt. Er muss seine
  // Identität behalten, auch wenn im Browser noch eine andere Admin-Sitzung gespeichert ist.
  if (token && !explicitAuthorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(res => res, err => {
  const loginRequest = String(err.config?.url || '').replace(/\?.*$/, '').endsWith('/auth/login');
  const token = localStorage.getItem('admin_token');
  if (err.response?.status === 401 && !loginRequest && token && err.config?.headers?.Authorization === `Bearer ${token}`) {
    localStorage.removeItem('admin_token');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});

// WHATSAPP-OTP-STANDARD-001: Token nur an Code-auslösenden POSTs (Liste in lib/otpChannel.js), plus
// einmalige Wiederholung ohne Token, falls ein altes Backend es ablehnt. Zuletzt registriert: der
// Abmelde-Interceptor oben sieht die Originalantwort zuerst, wie bisher.
installOtpCapability(api);

export default api;
